import { ReactElement } from 'react';

import { StrongText, TextSeparator } from '@dreryk/react-components';
import { commonTranslationKeys, Translate, useTranslate } from '@dreryk/react-common';

import { formatTimesOfDay } from './PatientAvailabilityPreferenceCell.utils';
import { PatientAvailabilityListItem } from './PatientAvailabilityPreferenceCell.types';

type PatientAvailabilityPreferenceCellAvailabilitiesProps = {
   availabilities: PatientAvailabilityListItem[];
};

export const PatientAvailabilityPreferenceCellAvailabilities = (
   props: PatientAvailabilityPreferenceCellAvailabilitiesProps
): ReactElement => {
   const translate = useTranslate();
   return (
      <>
         {props.availabilities.map((availability) => (
            <TextSeparator key={availability.dayOfWeek}>
               <StrongText testId={availability.dayOfWeek}>
                  <Translate>{commonTranslationKeys.dayOfWeekAbbreviationMap[availability.dayOfWeek]}</Translate>
               </StrongText>
               <span>{formatTimesOfDay(availability.timesOfDay, translate)}</span>
            </TextSeparator>
         ))}
      </>
   );
};
